import type { ProjectSummary } from '../lib/api';
import { formatDuration } from '../lib/format';

interface Props {
  summary: ProjectSummary;
}

export function StatsRow({ summary }: Props) {
  const stats: Array<{
    label: string;
    value: string;
    tint: string;
    tooltip: string;
  }> = [
    {
      label: 'Project Time',
      value: formatDuration(summary.project_wall_clock_seconds),
      tint: 'text-midnight',
      tooltip: 'Wall-clock time with any activity. Overlap counted once.',
    },
    {
      label: 'Human',
      value: formatDuration(summary.human_seconds),
      tint: 'text-[#15803d]',
      tooltip: 'Sum of duration across human blocks.',
    },
    {
      label: 'Agent Labor',
      value: formatDuration(summary.agent_labor_seconds),
      tint: 'text-[#b45309]',
      tooltip: 'Sum of duration across agent blocks. Parallel agents add up.',
    },
    {
      label: 'Agent Active',
      value: formatDuration(summary.agent_wall_clock_seconds),
      tint: 'text-[#ca8a04]',
      tooltip: 'Wall-clock time with at least one agent running.',
    },
    {
      label: 'Blocks',
      value: String(summary.block_count),
      tint: 'text-black',
      tooltip: 'Number of tracked blocks in the selected range.',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-5">
      {stats.map((stat) => (
        <div
          key={stat.label}
          className="card p-5"
          title={stat.tooltip}
        >
          <div className="mono-label text-black/50 mb-3">{stat.label}</div>
          <div
            className={`font-display text-[2.5rem] font-medium tracking-section leading-[1.05] ${stat.tint}`}
          >
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
}
